/*
 * @Date: 2022-07-04 17:34:40
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 */
export default {
  M: "月",
  Y: "年",
  empty: "暂无数据",
  stockInfo: "股价信息",
  stockInfoRmk: "数据由Refinitiv提供。 至少延迟15分钟。"
}